/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit, Input } from "@angular/core";

import { Rule } from "../../../models/rule";
import { RuleCondition } from "../../../models/rule-condition";

@Component({
  selector: 'app-day-parameter-editor',
  templateUrl: './day-parameter-editor.component.html'
})
export class DayParameterEditorComponent implements OnInit {

    @Input()
    rule: Rule;

    @Input()
    ruleCondition: RuleCondition;
    
    showBody: boolean = true;
    
    dayValues: string[];
    
    days = [
        { label: 'MON.', value: 'MONDAY', checked: true},
        { label: 'TUES.', value: 'TUESDAY', checked: true},
        { label: 'WED.', value: 'WEDNESDAY', checked: true},
        { label: 'THUR.', value: 'THURSDAY', checked: true},
        { label: 'FRI.', value: 'FRIDAY', checked: true},
        { label: 'SAT.', value: 'SATURDAY', checked: true},
        { label: 'SUN.', value: 'SUNDAY', checked: true}
    ];
    
    ngOnInit(): void {
       if (this.ruleCondition.propertyValue != null && this.ruleCondition.propertyValue.length > 0) {
          const dayValues = this.ruleCondition.propertyValue.split(';');

          for (let day of this.days) {
              if (dayValues.indexOf(day.value) == -1) {
                  day.checked = false;
              }
          }
       }
    }
    
    onDayClick(event: any): void {
        if (event.target.checked) {
            const days = this.ruleCondition.propertyValue.split(';');
            days.push(event.target.value);
            this.ruleCondition.propertyValue = days.join(';');
        }
        else {
            this.ruleCondition.propertyValue = this.ruleCondition.propertyValue.split(';').filter(d => d != event.target.value).join(';');
        }
    }
    
    onRemove(): void {
        const index = this.rule.conditions.indexOf(this.ruleCondition);
        
        if (index > -1) {
            this.rule.conditions.splice(index, 1);
        }
    }

}
